
import { useNavigate } from 'react-router';

import { useDispatch } from 'react-redux';

import { Button, ListItemText, Typography } from '@mui/material';

import { ListItembuttonStyle, ListItemIconStyle, ListItemTextStyle, ListTypographyStyle } from '../../styles/ListItemStyle';

import { MdAllInbox } from "react-icons/md";

import { setReducerClear } from '../../store/slices/RecepcionSlice';
import { setReducerBandeja } from '../../store/slices/BandejaReducer';

export const ListItemBandeja = () => {

    const dispatch = useDispatch();

    const navigate = useNavigate();

    const handleClick = () => {

        navigate('/');
        dispatch( setReducerClear() );
        dispatch( setReducerBandeja({ open: true }) ); 

    }

    return (     
            
        <ListItemText style={ ListItemTextStyle }>

            <Button color="inherit" style={ ListItembuttonStyle } onClick={ handleClick }>

                <MdAllInbox style={ ListItemIconStyle } />

                <Typography sx={{ ...ListTypographyStyle, display: { xs: 'none', lg: 'flex' } }} >
                    Bandeja
                </Typography>
                                        
            </Button>   

        </ListItemText>  
    )
}